import { useSelector } from 'react-redux'
import userSelectors from '../store/selectors/user.selectors'
import conceptualLabelSelectors from '../store/selectors/conceptual-label.selectors'
import { useFetchConceptualLabelsQuery } from '../store/apis/conceptual-label.api'
import { fetchConceptualLabelsSelectors } from '../store/apis/utils/selectors/conceptual-label.api.selectors'

/**
 * Hook to determine if the current user can edit a conceptual label
 * @param {string} [id] - Optional conceptual label ID. If not provided, uses editingConceptualLabelId from Redux
 * @returns {Object} - { canEdit: boolean, conceptualLabel: Object }
 */
const useConceptualLabel = (id) => {
    const isSenseUser = useSelector(userSelectors.isSenseUser)
    const editingConceptualLabelId = useSelector(conceptualLabelSelectors.editingConceptualLabelId)
    
    const targetId = id || editingConceptualLabelId

    const { data: conceptualLabel, ...rest } = useFetchConceptualLabelsQuery(
        null,
        {
            selectFromResult: result => fetchConceptualLabelsSelectors.byId({ id: targetId }, result),
            skip: !targetId,
        },
    )
    
    const canEdit = conceptualLabel ? (!conceptualLabel.isSystem || isSenseUser) : false
    
    return { canEdit, conceptualLabel, ...rest }
}

export default useConceptualLabel 